import posthog, { type PostHog } from 'posthog-js'
import { getPostHogApiHost } from '@percent/utility'

import { env } from '@percent/cause-dashboard/env'

const INSTANCE_NAME_PREFIX = 'backendFlags'

const clients = new Map<string, PostHog>()

// One instance per account, unlike the portal's client: with person_profiles 'never' posthog-js ignores identify()
export const getBackendFlagsClient = (accountId: string): PostHog | undefined => {
  const token = env.NX_PUBLIC_POSTHOG_BACKEND_PROJECT_KEY

  if (!token) {
    return undefined
  }

  const existing = clients.get(accountId)

  if (existing) {
    return existing
  }

  const instanceName = `${INSTANCE_NAME_PREFIX}_${accountId}`

  const client = posthog.init(
    token,
    {
      api_host: getPostHogApiHost(window.location.hostname),
      ui_host: 'https://eu.posthog.com',
      persistence: 'memory',
      // Own storage per account: without it, a second user logging in without a refresh got the first user's id
      persistence_name: instanceName,
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      disable_session_recording: true,
      disable_surveys: true,
      disable_external_dependency_loading: true,
      person_profiles: 'never',
      bootstrap: { distinctID: accountId, isIdentifiedID: true }
    },
    instanceName
  )

  clients.set(accountId, client)

  return client
}
